import { render, staticRenderFns } from "./titleModel.vue?vue&type=template&id=1a255a10&"
import script from "./titleModel.vue?vue&type=script&lang=js&"
export * from "./titleModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports